import React, { useState } from "react";
import Slider from "react-slick";
import { useI18N } from "../../../my-puratos/hoc/withI18N";

export const ProductCardSlider = ({ title, componentId = null, children }) => {
  const translate = useI18N();

  const sliderResponsiveness = [
    {
      breakpoint: 1399,
      settings: {
        slidesToShow: 3.01,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 999,
      settings: {
        slidesToShow: 2.01,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 759,
      settings: {
        slidesToShow: 1.2,
        slidesToScroll: 1,
      }
    },
  ];

  const sliderRef = React.useRef(null);
  const [isSliderEnabled, setIsSliderEnabled] = useState(false);

  const [isFirstSlide, setIsFirstSlide] = useState(true);
  const [isLastSlide, setIsLastSlide] = useState(false);
  const [progressPercentage, setProgressPercentage] = useState(0);

  function CarouselPseudoArrow(props) {
    const { className } = props;
    if (props.type === "prev") {
      setIsFirstSlide(className.includes("slick-disabled"));
    } else {
      setIsLastSlide(className.includes("slick-disabled"));
    }
    return (
      <div />
    );
  }

  const sliderSettings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4.01,
    slidesToScroll: 1,
    swipeToSlide: true,
    responsive: sliderResponsiveness,
    prevArrow: <CarouselPseudoArrow type="prev"/>,
    nextArrow: <CarouselPseudoArrow type="next"/>,
    onReInit: () => {
      const slidesCount = sliderRef?.current?.props?.children.length;
      let showingSlides = 4;
      const currentResponsive = sliderRef?.current?.props?.responsive.filter((x) => (x.breakpoint === sliderRef?.current?.state.breakpoint));
      if (currentResponsive.length) {
        showingSlides = currentResponsive[0].settings.slidesToShow;
      }
      setIsSliderEnabled(slidesCount > showingSlides);
    },
    beforeChange: (oldIndex, newIndex) => {
      const slidesCount = sliderRef?.current?.props?.children.length;
      let showingSlides = 4;
      const currentResponsive = sliderRef?.current?.props?.responsive.filter((x) => (x.breakpoint === sliderRef?.current?.state.breakpoint));
      if (currentResponsive.length) {
        showingSlides = currentResponsive[0].settings.slidesToShow;
      }

      let percentageLeft;
      let slidesLeft = slidesCount - showingSlides;
      if (newIndex === 0) {
        percentageLeft = 0;
      }
      else if (slidesLeft <= 0) {
        percentageLeft = 100;
      } else {
        percentageLeft = (newIndex / slidesLeft) * 100;
      }

      setProgressPercentage(percentageLeft);
    }
  };

  return (
    <div className={`product-card-slider ${!isSliderEnabled ? "slider-disabled" : ""}`}>
      <div className="product-card-slider-header">
        <h2
          className="product-card-slider-title"
          {...(componentId ? { id: componentId } : {})}>
          {title}
        </h2>
        <div className="product-card-slider-navigation">
          <button aria-label={translate('Previous card')} onClick={() => sliderRef?.current?.slickPrev()} disabled={isFirstSlide} className="slick-prev slick-arrow" />
          <button aria-label={translate('Next card')} onClick={() => sliderRef?.current?.slickNext()} disabled={isLastSlide} className="slick-next slick-arrow" />
        </div>
      </div>
      <div className="product-card-slider-content">
        <Slider ref={sliderRef} {...sliderSettings} className="product-card-container-slider">
          {children}
        </Slider>
      </div>
      <div className="product-card-slider-progress">
        <span className="product-card-slider-progress--value" style={{ "--progress-value": `${progressPercentage}%` } as React.CSSProperties}></span>
      </div>
    </div>
  )
}
